import React, {PropsWithChildren} from "react";
import {Modal} from "./Modal";
import {Button} from "../ui-components/Button/Button";

interface PromptModalProps extends PropsWithChildren {
    onConfirmCallback: () => void;
    onDeclineCallback: () => void;
}

export const PromptModal: React.FunctionComponent<PromptModalProps> = (props) => {
    return <Modal>
        <header></header>
        <main className={'prompt-container'}>
            <div className={'prompt-container'}>
                {props.children}
            </div>

        </main>
        <footer>
            <Button className='white-button' onClick={() => {
                props.onDeclineCallback()
            }}>No</Button>
            <Button onClick={() => {
                props.onConfirmCallback()
            }}>Yes</Button>
        </footer>
    </Modal>

}